import { render } from "./os-form.vue?vue&type=template&id=3c9605d8"
import script from "./os-form.vue?vue&type=script&lang=js"
export * from "./os-form.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__